<template>
  <div class="table-grid bottom-grid">
    <DashboardPanel title="Stock Alerts" subtitle="Low stock and out of stock items with thresholds.">
      <template #actions>
        <button class="link-btn" @click="$router.push('/productlist')">Open Inventory</button>
      </template>
      <div class="alert-summary">
        <span class="pill pill-warn">Low: {{ stockAlerts.low_stock_count }}</span>
        <span class="pill pill-danger">Out: {{ stockAlerts.out_of_stock_count }}</span>
      </div>
      <div class="table-responsive">
        <a-table :columns="stockAlertColumns" :data-source="stockAlertRows" :pagination="false" row-key="rowkey" size="small" />
      </div>
    </DashboardPanel>

    <DashboardPanel title="Top Vendors" subtitle="Highest purchase spend for the current month.">
      <template #actions>
        <button class="link-btn" @click="$router.push('/supplierlist')">Open Suppliers</button>
      </template>
      <div class="mini-list" v-if="topVendors.length">
        <div class="mini-row" v-for="vendor in topVendors" :key="vendor.vendorid || vendor.vendorname">
          <div>
            <strong>{{ vendor.vendorname }}</strong>
            <span>{{ vendor.bill_count }} bills</span>
          </div>
          <div class="text-end">
            <strong>{{ formatCurrency(vendor.total_spend) }}</strong>
          </div>
        </div>
      </div>
      <div class="empty-state" v-else>No vendor spend data yet.</div>
    </DashboardPanel>
  </div>
</template>

<script>
import DashboardPanel from "./DashboardPanel.vue";
import { buildStockAlertRows } from "../dashboardCards";
import { formatCurrency } from "@/utils/formatters";

const STOCK_ALERT_COLUMNS = [
  { title: "Item", dataIndex: "itemname", key: "itemname" },
  { title: "Category", dataIndex: "categoryname", key: "categoryname" },
  { title: "Available", dataIndex: "available", key: "available", align: "right" },
  { title: "Min Stock", dataIndex: "minstock", key: "minstock", align: "right" },
];

// Low / out-of-stock alerts and the top vendors by spend.
export default {
  name: "InventorySection",
  components: { DashboardPanel },
  props: {
    stockAlerts: { type: Object, required: true },
    topVendors: { type: Array, required: true },
  },
  data() {
    return { stockAlertColumns: STOCK_ALERT_COLUMNS };
  },
  computed: {
    stockAlertRows() {
      return buildStockAlertRows(this.stockAlerts);
    },
  },
  methods: { formatCurrency },
};
</script>
